<section class="season-wizard">
  <app-admin-page-header [title]="title" [subtitle]="subtitle"></app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>

  <form class="admin-surface season-wizard__form" (ngSubmit)="save()">
    <h3>1. Temporada</h3>
    <div class="season-wizard__grid">
      <label>
        <span>Nome da temporada</span>
        <input class="admin-input" [(ngModel)]="seasonName" name="seasonName" required />
      </label>

      <label>
        <span>Início</span>
        <input
          class="admin-input"
          type="datetime-local"
          [(ngModel)]="startDateLocal"
          name="startDateLocal"
          required />
      </label>

      <label>
        <span>Fim</span>
        <input
          class="admin-input"
          type="datetime-local"
          [(ngModel)]="endDateLocal"
          name="endDateLocal"
          required />
      </label>
    </div>

    <h3>2. Passe de batalha</h3>
    <div class="season-wizard__grid">
      <label>
        <span>Nome do passe</span>
        <input class="admin-input" [(ngModel)]="battlePassName" name="battlePassName" required />
      </label>

      <label>
        <span>Preço em gemas</span>
        <input
          class="admin-input"
          type="number"
          [(ngModel)]="priceGems"
          name="priceGems"
          min="0" />
      </label>

      <label>
        <span>Preço em moedas</span>
        <input
          class="admin-input"
          type="number"
          [(ngModel)]="priceCoins"
          name="priceCoins"
          min="0" />
      </label>
    </div>

    <label>
      <span>Descrição do passe</span>
      <textarea
        class="admin-input"
        rows="4"
        [(ngModel)]="battlePassDescription"
        name="battlePassDescription"></textarea>
    </label>

    <h3>3. Template (opcional)</h3>
    <div class="season-wizard__grid">
      <label>
        <span>Temporada template</span>
        <select class="admin-input" [(ngModel)]="templateSeasonId" name="templateSeasonId">
          <option [ngValue]="undefined">Sem template</option>
          <option *ngFor="let season of templates" [ngValue]="season.id">
            #{{ season.id }} - {{ season.name }}
          </option>
        </select>
      </label>
    </div>

    <div class="season-wizard__checks">
      <label>
        <input type="checkbox" [(ngModel)]="cloneMissions" name="cloneMissions" />
        Clonar missões
      </label>
      <label>
        <input type="checkbox" [(ngModel)]="cloneLevels" name="cloneLevels" />
        Clonar níveis
      </label>
      <label>
        <input type="checkbox" [(ngModel)]="cloneRewards" name="cloneRewards" />
        Clonar recompensas do passe
      </label>
    </div>

    <div class="season-wizard__actions">
      <button class="admin-btn admin-btn--secondary" type="button" [routerLink]="['/dashboard/temporadas']">
        Cancelar
      </button>
      <button class="admin-btn admin-btn--primary" type="submit" [disabled]="isSaving">
        {{ isSaving ? 'Criando...' : 'Criar temporada' }}
      </button>
    </div>
  </form>
</section>
